<!-- Modal For Relogin -->
<div class="relogin-overlay-custom" *ngIf="displayRelogin || displayReloginMfa"></div>
<p-dialog [focusOnShow]="false" class="relogin-popup" header="Your session has expired" [closable]="false" [(visible)]="displayRelogin" [modal]="true"  [draggable]="false"
  [blockScroll]="true">
  <form [formGroup]="reloginForm" (ngSubmit)="onSubmit()" id="reLogin">
    <div class="content-row">
      <div class="alert-message" *ngIf="msgs && msgs.length > 0">
        <p-message closable *ngFor="let msg of msgs" [severity]="msg.severity" [text]="msg.summary"></p-message>
      </div>
      <div class="row">
        <div class="col col-12">
          Your session has timed out, this could be down to a few of reasons such as: Your browser going offline, Having two browser tabs open and logging out of one while leaving the other open or that you have left the same screen open for too long.
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col col-12">
          <strong>Please enter your password to re-join the session</strong>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col col-4">
          <strong>Password</strong>
        </div>
        <div class="col col-8">
          <input type="password" class="input" id="inputPassword" placeholder="Password" formControlName="password"
            [ngClass]="{'is-invalid':  f.password.errors && f.password.dirty }">
          <!-- Password Validations and Error Message -->
          <div *ngIf="f.password.errors && f.password.dirty" class="invalid-feedback">
            <div *ngIf="f.password.errors.required" class="error-message-form">Password is required</div>
            <div *ngIf="f.password.errors.minlength" class="error-message-form">Password must be at least 8 characters long</div>
          </div>
        </div>
      </div>
      <br>
    </div>
    <div  >
      <div class="btns">
        <input class="btn btn-primary submit" name="submit" type="submit" value="Re-join" [disabled]="!reloginForm.valid" [style.display]="submitted?'none':''">
      </div>
    </div>
  </form>
</p-dialog>
<p-dialog [focusOnShow]="false" class="relogin-popup" header="Enter your MFA code" [closable]="false" [(visible)]="displayReloginMfa" [modal]="true" [responsive]="true" [draggable]="false"
  [blockScroll]="true">
  <form [formGroup]="reloginMfaForm" (ngSubmit)="onSubmitMfa()" id="reLoginMfa">
    <div class="content-row">
      <div class="alert-message resend-code" *ngIf="msgs && msgs.length > 0">
        <p-message closable [(value)]="msgs"></p-message>
      </div>
      <div class="row">
        <div class="col col-12">
          Please enter the MFA code emailed to you to complete sign-in, or click <a class="back-to-login" (click)="backToLogin()">here</a> to logout.
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col col-4">
          <strong>MFA code</strong>
        </div>
        <div class="col col-8">
          <input type="text" class="input" id="inputMfaCode" placeholder="MFA code" formControlName="mfaCode" [(ngModel)]="mfaCode" (keypress)="codeLength($event)" 
            [ngClass]="{'is-invalid':  m.mfaCode.errors && m.mfaCode.dirty }">
          <!-- MFA code Validations and Error Message -->
          <div *ngIf="m.mfaCode.errors && m.mfaCode.dirty" class="invalid-feedback">
            <div *ngIf="m.mfaCode.errors.required" class="error-message-form">MFA code is required</div>
            <div *ngIf="m.mfaCode.errors.minlength" class="error-message-form">MFA code must be 6 digits long</div>
            <div *ngIf="m.mfaCode.errors.maxlength" class="error-message-form">MFA code must be 6 digits long</div>
          </div>
        </div>
      </div>
      <br>
    </div>
    <p-footer>
      <div class="row btns">
        <div class="col col-6">
          <input class="btn btn-primary login-resend" name="resend" type="button" value="Resend Code" [disabled]="limitResend" (click)="resendCode()">
        </div>
        <div class="col col-6">
          <input class="btn btn-primary submit" name="submit" type="submit" value="Verify" [disabled]="!reloginMfaForm.valid" [style.display]="submitted?'none':''">
        </div>
      </div>
    </p-footer>
  </form>
</p-dialog>